import { SERVICE_HEADER } from "../actions/Consts";
import Config from "../config/Configs";

export const sendGAEvent = ({ category = "", action = "", label = "" }) => {
    window.ga("send", {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    })
}
export const mobilecheck = () => {
    return /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
};

export const launchPostInTab = function (url, params, headers) {
    
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", url);
    form.setAttribute("enctype", "application/json");
    form.setAttribute("target", "Download");
    params.apiKey = Config.apiKey;
    for (var i in params) {
        if (params.hasOwnProperty(i)) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
        }
    }

    document.body.appendChild(form);

    //note I am using a post.htm page since I did not want to make double request to the page 
    //it might have some Page_Load call which might screw things up.
    window.open("post.htm", "Download");

    form.submit();

    document.body.removeChild(form);
}